import React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { getSizeValue, TypographyVariant, useHoneycombTheme } from '../../theming';

export const STATIC_STYLES: SerializedStyles = css`
    --temperature-chart-bar-color: var(--hc-color-neutral-tint-200);
    --temperature-chart-bar-color-active: var(--hc-color-primary-base);

    /* Chart root */
    text-anchor: middle;
    width: 100%;
    max-width: var(--temperature-chart-width);
    height: auto;

    [data-temperature-chart-month] {
        font-size: var(--temperature-chart-font-size);
        font-weight: var(--temperature-chart-font-weight);

        > rect {
            outline: none;
            fill: var(--temperature-chart-bar-color);
        }

        &[data-active] {
            font-weight: var(--temperature-chart-font-weight-active);

            > rect {
                fill: var(--temperature-chart-bar-color-active);
            }
        }
    }
`;

export function useDynamicStyles(width: number, fontVariant: TypographyVariant): React.CSSProperties {
    const { theme } = useHoneycombTheme();

    const styles = React.useMemo(() => {
        const typographyProps = theme.fn.getTypographyVariant(fontVariant);

        return {
            '--temperature-chart-width': getSizeValue(width),
            '--temperature-chart-font-size': typographyProps.fontSize,
            '--temperature-chart-font-weight': typographyProps.fontWeight.default,
            '--temperature-chart-font-weight-active': typographyProps.fontWeight.bold,
        };
    }, [fontVariant, theme.fn, width]);

    return styles as React.CSSProperties;
}
